<template>
  <!-- Conteneur principal épuré et adaptatif -->
  <div class="px-6 py-6 space-y-6 min-h-screen select-none text-left transition-colors duration-200 font-sans"
    :class="isDark ? 'bg-zinc-950 text-zinc-400' : 'bg-zinc-50 text-zinc-600'">

    <!-- En-tête principal -->
    <div class="border-b pb-5 transition-colors duration-200" :class="isDark ? 'border-zinc-900' : 'border-zinc-200'">
      <h1 class="text-xl font-semibold tracking-tight transition-colors duration-200"
        :class="isDark ? 'text-white' : 'text-zinc-900'">Import & Synchronisation</h1>
      <p class="text-xs font-medium transition-colors duration-200" :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
        Récupérez vos rendez-vous existants ou connectez directement votre agenda externe.
      </p>
    </div>

    <!-- Section Connexion Agenda (Design Premium) -->
    <div class="border rounded-2xl p-6 space-y-5 transition-all duration-200"
      :class="isDark 
        ? 'bg-gradient-to-br from-blue-950/10 via-zinc-900/10 to-zinc-900/20 border-blue-900/30' 
        : 'bg-white border-zinc-200/80 shadow-sm'">
      
      <div class="flex sm:flex-row flex-col justify-between items-start sm:items-center gap-4">
        <div class="flex items-center gap-3">
          <div class="w-12 h-12 rounded-xl flex items-center justify-center border transition-colors"
            :class="isDark ? 'bg-zinc-900/50 border-zinc-800 text-blue-400' : 'bg-blue-50 border-blue-100 text-blue-600'">
            <i class="fas fa-sync-alt text-lg"></i>
          </div>
          <div>
            <h2 class="text-base font-semibold transition-colors" :class="isDark ? 'text-white' : 'text-zinc-900'">Synchronisation d'agenda</h2>
            <p class="text-xs font-medium" :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">Connectez votre compte pour une mise à jour fluide de vos créneaux.</p>
          </div>
        </div>
        <button
          v-if="!hasConnections"
          @click="connectGoogleCalendar"
          :disabled="isConnecting"
          class="px-4 py-2.5 rounded-xl text-xs font-semibold transition-all shadow-sm disabled:opacity-50 flex items-center gap-2 cursor-pointer focus:outline-none"
          :class="isDark ? 'bg-white hover:bg-zinc-200 text-black' : 'bg-zinc-900 hover:bg-zinc-800 text-white'"
        >
          <i class="fab fa-google"></i>
          {{ isConnecting ? 'Connexion...' : 'Associer Google Calendar' }}
        </button>
      </div>

      <!-- Liste des agendas connectés -->
<!-- Liste des agendas connectés -->
<div v-if="connections.length > 0" class="space-y-3">
  <!-- 💡 LE CHANGEMENT EST ICI : On ajoute v-for pour boucler sur chaque connexion -->
  <div v-for="item in connections" :key="item.id" 
    class="border rounded-xl p-4 space-y-4 transition-colors"
    :class="isDark ? 'bg-zinc-950/60 border-zinc-900' : 'bg-zinc-50/50 border-zinc-200/60'">
    
    <div class="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center border"
          :class="isDark ? 'bg-zinc-900 border-zinc-800 text-blue-400' : 'bg-white border-zinc-200 text-blue-500 shadow-sm'">
          <i class="fab fa-google"></i>
        </div>
        <div>
          <p class="text-sm font-semibold transition-colors" :class="isDark ? 'text-white' : 'text-zinc-900'">
            <!-- 💡 On utilise 'item' au lieu de 'connections' -->
            {{ item.accountName || item.accountEmail }}
          </p>
          <p class="text-xs font-medium" :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">
            {{ item.calendarName }}
          </p>

        </div>
      </div>

      <!-- Boutons d'actions de la connexion -->
      <div class="flex items-center gap-2">
        <button
          @click="syncCalendar(item.id)"
          :disabled="isSyncing"
          class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors flex items-center cursor-pointer focus:outline-none"
          :class="isDark ? 'bg-blue-600 text-white hover:bg-blue-500 disabled:bg-zinc-900' : 'bg-blue-50 text-blue-700 hover:bg-blue-100/80'"
        >
          <i class="fas fa-sync-alt mr-1.5" :class="{ 'animate-spin': isSyncing }"></i>
          Mettre à jour
        </button>
        <button
          @click="disconnectCalendar(item.id)"
          class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors flex items-center cursor-pointer focus:outline-none"
          :class="isDark ? 'bg-zinc-900 text-zinc-400 hover:text-red-400 hover:bg-red-950/20' : 'bg-white text-zinc-500 hover:text-rose-600 hover:bg-rose-50 border border-zinc-200'"
        >
          <i class="fas fa-unlink mr-1.5"></i>
          Détacher
        </button>
      </div>
    </div>


  </div>
</div>

      <!-- État vide de connexion -->
      <div v-else class="border rounded-xl p-6 text-center transition-colors"
        :class="isDark ? 'bg-zinc-950/40 border-zinc-900' : 'bg-zinc-50/40 border-zinc-100'">
        <i class="fas fa-plug text-2xl mb-2.5" :class="isDark ? 'text-zinc-700' : 'text-zinc-300'"></i>
        <p class="text-xs font-semibold" :class="isDark ? 'text-zinc-400' : 'text-zinc-700'">Aucun agenda associé</p>
        <p class="text-[11px] mt-0.5" :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">Liez votre compte Google Calendar pour automatiser la gestion de vos rendez-vous.</p>
      </div>
    </div>

    <!-- Deux blocs d'import manuels
    <div class="grid lg:grid-cols-2 gap-6">

     
      <div class="border rounded-2xl p-6 space-y-5 transition-colors"
        :class="isDark ? 'bg-zinc-900/20 border-zinc-900' : 'bg-white border-zinc-200/80 shadow-sm'">
        <div class="flex items-center gap-3 border-b pb-4 transition-colors" :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center border"
            :class="isDark ? 'bg-zinc-900 border-zinc-800 text-emerald-400' : 'bg-emerald-50 border-emerald-100 text-emerald-600'">
            <i class="fas fa-file-csv text-base"></i>
          </div>
          <div>
            <h2 class="text-sm font-semibold" :class="isDark ? 'text-white' : 'text-zinc-900'">Fichier Excel ou CSV</h2>
            <p class="text-xs font-medium" :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">Idéal pour transférer un fichier de données clients</p>
          </div>
        </div>

        <div class="space-y-4">
         
          <div class="border rounded-xl p-4 space-y-2.5 transition-colors"
            :class="isDark ? 'bg-zinc-950/40 border-zinc-900' : 'bg-zinc-50/50 border-zinc-200/60'">
            <p class="text-[11px] font-bold" :class="isDark ? 'text-zinc-400' : 'text-zinc-500'">Structure du fichier requise :</p>
            <div class="flex flex-wrap gap-1.5 text-[10px] font-semibold">
              <span class="px-2 py-0.5 rounded" :class="isDark ? 'bg-zinc-900 text-zinc-300' : 'bg-white border border-zinc-200 text-zinc-600'">client</span>
              <span class="px-2 py-0.5 rounded" :class="isDark ? 'bg-zinc-900 text-zinc-300' : 'bg-white border border-zinc-200 text-zinc-600'">telephone</span>
              <span class="px-2 py-0.5 rounded" :class="isDark ? 'bg-zinc-900 text-zinc-300' : 'bg-white border border-zinc-200 text-zinc-600'">email</span>
              <span class="px-2 py-0.5 rounded" :class="isDark ? 'bg-zinc-900 text-zinc-300' : 'bg-white border border-zinc-200 text-zinc-600'">date</span>
              <span class="px-2 py-0.5 rounded" :class="isDark ? 'bg-zinc-900 text-zinc-300' : 'bg-white border border-zinc-200 text-zinc-600'">heure</span>
              <span class="px-2 py-0.5 rounded" :class="isDark ? 'bg-zinc-900 text-zinc-300' : 'bg-white border border-zinc-200 text-zinc-600'">service</span>
            </div>
          </div>

        
          <div class="space-y-3">
            <label class="block">
              <div class="border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-all"
                :class="isDark 
                  ? 'border-zinc-800 hover:border-zinc-700 bg-zinc-950/20' 
                  : 'border-zinc-200 hover:border-zinc-300 bg-zinc-50/50'">
                <input type="file" @change="handleCsvUpload" accept=".csv,.xlsx,.xls" class="hidden" ref="csvInput" />
                <i class="fas fa-cloud-upload-alt text-2xl mb-2" :class="isDark ? 'text-zinc-700' : 'text-zinc-400'"></i>
                <p class="text-xs font-medium" :class="isDark ? 'text-zinc-400' : 'text-zinc-600'">Parcourir et sélectionner votre fichier</p>
                <p v-if="csvFile" class="text-xs text-emerald-500 mt-2 font-semibold">
                  <i class="fas fa-check-circle mr-1"></i> {{ csvFile.name }}
                </p>
              </div>
            </label>

           
            <button
              @click="importCsv"
              :disabled="!csvFile || isImporting"
              class="w-full py-3 rounded-xl text-xs font-semibold transition-colors disabled:opacity-40 cursor-pointer focus:outline-none shadow-sm"
              :class="isDark ? 'bg-emerald-600 hover:bg-emerald-500 text-white' : 'bg-zinc-900 hover:bg-zinc-800 text-white'"
            >
              {{ isImporting ? 'Chargement...' : 'Lancer l\'importation' }}
            </button>

            <button
              @click="downloadTemplate"
              class="w-full border py-2.5 rounded-xl text-xs font-semibold transition-colors cursor-pointer focus:outline-none shadow-sm"
              :class="isDark ? 'bg-zinc-900 hover:bg-zinc-800 border-zinc-800 text-zinc-400' : 'bg-white hover:bg-zinc-50 border-zinc-200 text-zinc-600'"
            >
              Télécharger le modèle (.csv)
            </button>
          </div>
        </div>
      </div>

      <div class="border rounded-2xl p-6 space-y-5 transition-colors"
        :class="isDark ? 'bg-zinc-900/20 border-zinc-900' : 'bg-white border-zinc-200/80 shadow-sm'">
        <div class="flex items-center gap-3 border-b pb-4 transition-colors" :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center border"
            :class="isDark ? 'bg-zinc-900 border-zinc-800 text-blue-400' : 'bg-blue-50 border-blue-100 text-blue-600'">
            <i class="fas fa-calendar-alt text-base"></i>
          </div>
          <div>
            <h2 class="text-sm font-semibold" :class="isDark ? 'text-white' : 'text-zinc-900'">Fichier iCalendar (.ics)</h2>
            <p class="text-xs font-medium" :class="isDark ? 'text-zinc-500' : 'text-zinc-400'">Format standard des calendriers numériques</p>
          </div>
        </div>

        <div class="space-y-4">
        
          <div class="border rounded-xl p-4 space-y-2 transition-colors"
            :class="isDark ? 'bg-zinc-950/40 border-zinc-900' : 'bg-zinc-50/50 border-zinc-200/60'">
            <p class="text-[11px] font-bold" :class="isDark ? 'text-zinc-400' : 'text-zinc-500'">Agendas compatibles :</p>
            <div class="flex flex-wrap gap-1.5 text-[10px] font-semibold">
              <span class="px-2 py-0.5 rounded border" :class="isDark ? 'bg-zinc-900 border-zinc-800 text-zinc-400' : 'bg-white border-zinc-200 text-zinc-500'"><i class="fab fa-google mr-1"></i>Google</span>
              <span class="px-2 py-0.5 rounded border" :class="isDark ? 'bg-zinc-900 border-zinc-800 text-zinc-400' : 'bg-white border-zinc-200 text-zinc-500'"><i class="fab fa-apple mr-1"></i>Apple</span>
              <span class="px-2 py-0.5 rounded border" :class="isDark ? 'bg-zinc-900 border-zinc-800 text-zinc-400' : 'bg-white border-zinc-200 text-zinc-500'"><i class="fab fa-microsoft mr-1"></i>Outlook</span>
            </div>
          </div>

       
          <div class="space-y-3">
            <label class="block">
              <div class="border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-all"
                :class="isDark 
                  ? 'border-zinc-800 hover:border-zinc-700 bg-zinc-950/20' 
                  : 'border-zinc-200 hover:border-zinc-300 bg-zinc-50/50'">
                <input type="file" @change="handleIcalUpload" accept=".ics" class="hidden" ref="icalInput" />
                <i class="fas fa-calendar-check text-2xl mb-2" :class="isDark ? 'text-zinc-700' : 'text-zinc-400'"></i>
                <p class="text-xs font-medium" :class="isDark ? 'text-zinc-400' : 'text-zinc-600'">Sélectionner un fichier .ics</p>
                <p v-if="icalFile" class="text-xs text-blue-500 mt-2 font-semibold">
                  <i class="fas fa-check-circle mr-1"></i> {{ icalFile.name }}
                </p>
              </div>
            </label>

          
            <button
              @click="importIcal"
              :disabled="!icalFile || isImporting"
              class="w-full py-3 rounded-xl text-xs font-semibold transition-colors disabled:opacity-40 cursor-pointer focus:outline-none shadow-sm"
              :class="isDark ? 'bg-blue-600 hover:bg-blue-500 text-white' : 'bg-zinc-900 hover:bg-zinc-800 text-white'"
            >
              {{ isImporting ? 'Chargement...' : 'Importer l\'agenda' }}
            </button>

            <button
              @click="exportIcal"
              class="w-full border py-2.5 rounded-xl text-xs font-semibold transition-colors cursor-pointer focus:outline-none shadow-sm"
              :class="isDark ? 'bg-zinc-900 hover:bg-zinc-800 border-zinc-800 text-zinc-400' : 'bg-white hover:bg-zinc-50 border-zinc-200 text-zinc-600'"
            >
              Sauvegarder mes RDV au format .ics
            </button>
          </div>
        </div>
      </div>

    </div> -->

-



  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { toast } from 'vue3-toastify'
import api from '@/api'
import { useTheme } from '@/composables/useTheme';

// Variable globale injectée ou reçue par props pour basculer de thème
const { isDark } = useTheme();
const route = useRoute()

// const csvFile = ref(null)
// const icalFile = ref(null)
// const isImporting = ref(false)
// const importResult = ref(null)

// const csvInput = ref(null)
// const icalInput = ref(null)

// Calendar connections
const connections = ref([])
const isConnecting = ref(false)
const isSyncing = ref(false)

const hasConnections = computed(() => connections.value.length > 0)

// const handleCsvUpload = (event) => {
//   const file = event.target.files[0]
//   if (file) {
//     csvFile.value = file
//     toast.info('Fichier sélectionné : ' + file.name, {
//       position: 'top-right',
//       autoClose: 2000
//     })
//   }
// }

// const handleIcalUpload = (event) => {
//   const file = event.target.files[0]
//   if (file) {
//     icalFile.value = file
//     toast.info('Fichier sélectionné : ' + file.name, {
//       position: 'top-right',
//       autoClose: 2000
//     })
//   }
// }

// const importCsv = async () => {
//   if (!csvFile.value) {
//     toast.error('Veuillez sélectionner un fichier CSV')
//     return
//   }

//   try {
//     isImporting.value = true
//     console.log('📥 Import CSV en cours...')

//     const formData = new FormData()
//     formData.append('file', csvFile.value)

//     const response = await api.appointments.importCsv(formData)

//     console.log('✅ Import terminé:', response.data)

//     importResult.value = {
//       success: true,
//       message: 'Import terminé avec succès',
//       imported: response.data.imported,
//       errors: response.data.errors,
//       details: response.data.details
//     }

//     toast.success(`${response.data.imported} rendez-vous importés !`, {
//       position: 'top-right',
//       autoClose: 3000
//     })

//     // Reset le fichier
//     csvFile.value = null
//     if (csvInput.value) {
//       csvInput.value.value = ''
//     }

//   } catch (error) {
//     console.error('❌ Erreur lors de l\'import:', error)

//     importResult.value = {
//       success: false,
//       message: 'Erreur lors de l\'import',
//       imported: 0,
//       errors: 1,
//       details: {
//         errors: [{ error: error.response?.data?.message || error.message }]
//       }
//     }

//     toast.error('Erreur lors de l\'import')
//   } finally {
//     isImporting.value = false
//   }
// }

// const importIcal = async () => {
//   if (!icalFile.value) {
//     toast.error('Veuillez sélectionner un fichier .ics')
//     return
//   }

//   try {
//     isImporting.value = true
//     console.log('📅 Import iCalendar en cours...')

//     const formData = new FormData()
//     formData.append('file', icalFile.value)

//     const response = await api.appointments.importIcal(formData)

//     console.log('✅ Import terminé:', response.data)

//     importResult.value = {
//       success: true,
//       message: 'Import iCalendar terminé',
//       imported: response.data.imported,
//       errors: response.data.errors,
//       details: response.data.details
//     }

//     toast.success(`${response.data.imported} rendez-vous importés !`, {
//       position: 'top-right',
//       autoClose: 3000
//     })

//     // Reset le fichier
//     icalFile.value = null
//     if (icalInput.value) {
//       icalInput.value.value = ''
//     }

//   } catch (error) {
//     console.error('❌ Erreur lors de l\'import:', error)

//     importResult.value = {
//       success: false,
//       message: 'Erreur lors de l\'import iCalendar',
//       imported: 0,
//       errors: 1,
//       details: {
//         errors: [{ error: error.response?.data?.message || error.message }]
//       }
//     }

//     toast.error('Erreur lors de l\'import')
//   } finally {
//     isImporting.value = false
//   }
// }

// const downloadTemplate = async () => {
//   try {
//     console.log('📥 Téléchargement du template CSV...')

//     const response = await api.appointments.downloadCsvTemplate()

//     // Créer un blob et le télécharger
//     const blob = new Blob([response.data], { type: 'text/csv' })
//     const url = window.URL.createObjectURL(blob)
//     const link = document.createElement('a')
//     link.href = url
//     link.download = 'template_import_rdv.csv'
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     window.URL.revokeObjectURL(url)

//     toast.success('Template téléchargé !', {
//       position: 'top-right',
//       autoClose: 2000
//     })

//   } catch (error) {
//     console.error('❌ Erreur lors du téléchargement:', error)
//     toast.error('Erreur lors du téléchargement du template')
//   }
// }

// const exportIcal = async () => {
//   try {
//     console.log('📤 Export iCalendar en cours...')

//     const response = await api.appointments.exportIcal()

//     // Créer un blob et le télécharger
//     const blob = new Blob([response.data], { type: 'text/calendar' })
//     const url = window.URL.createObjectURL(blob)
//     const link = document.createElement('a')
//     link.href = url
//     link.download = 'mes_rendez_vous.ics'
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     window.URL.revokeObjectURL(url)

//     toast.success('Calendrier exporté !', {
//       position: 'top-right',
//       autoClose: 2000
//     })

//   } catch (error) {
//     console.error('❌ Erreur lors de l\'export:', error)
//     toast.error('Erreur lors de l\'export')
//   }
// }

// const clearResult = () => {
//   importResult.value = null
// }

// ===== Gestion des connexions calendrier =====

// Charger les connexions existantes
const loadConnections = async () => {
  try {
    const response = await api.calendar.getConnections()
    connections.value = response.data.connections || []
    console.log(connections)
    console.log('📅 Connexions chargées:', connections.value.length)
  } catch (error) {
    console.error('❌ Erreur lors du chargement des connexions:', error)
  }
}

// Connecter Google Calendar
const connectGoogleCalendar = async () => {
  try {
    isConnecting.value = true
    console.log('🔗 Connexion à Google Calendar...')

    const response = await api.calendar.getGoogleAuthUrl()
    const authUrl = response.data.authUrl

    // Ouvrir la fenêtre d'authentification Google
    window.location.href = authUrl

  } catch (error) {
    console.error('❌ Erreur lors de la connexion:', error)
    toast.error('Erreur lors de la connexion à Google Calendar')
    isConnecting.value = false
  }
}

// Synchroniser un calendrier
const syncCalendar = async (connectionId) => {
  try {
    isSyncing.value = true
    console.log('🔄 Synchronisation en cours...', connectionId)

    toast.info('Synchronisation en cours...', {
      position: 'top-right',
      autoClose: 2000
    })

    const response = await api.calendar.syncCalendar(connectionId)

    console.log('✅ Synchronisation terminée:', response.data)

    toast.success(`Synchronisation réussie ! ${response.data.imported} importés, ${response.data.exported} exportés`, {
      position: 'top-right',
      autoClose: 4000
    })

    // Recharger les connexions pour mettre à jour les stats
    await loadConnections()

  } catch (error) {
    console.error('❌ Erreur lors de la synchronisation:', error)
    toast.error('Erreur lors de la synchronisation')
  } finally {
    isSyncing.value = false
  }
}

// Déconnecter un calendrier
const disconnectCalendar = async (connectionId) => {
  if (!confirm('Êtes-vous sûr de vouloir déconnecter ce calendrier ?')) {
    return
  }

  try {
    console.log('🔌 Déconnexion du calendrier...', connectionId)

    await api.calendar.disconnectCalendar(connectionId)

    toast.success('Calendrier déconnecté', {
      position: 'top-right',
      autoClose: 2000
    })

    // Recharger les connexions
    await loadConnections()

  } catch (error) {
    console.error('❌ Erreur lors de la déconnexion:', error)
    toast.error('Erreur lors de la déconnexion')
  }
}

// Mettre à jour les paramètres de synchronisation
// const updateSyncSettings = async (connectionId, syncDirection) => {
//   try {
//     console.log('⚙️  Mise à jour des paramètres:', { connectionId, syncDirection })

//     await api.calendar.updateSettings(connectionId, { syncDirection })

//     toast.success('Paramètres mis à jour', {
//       position: 'top-right',
//       autoClose: 2000
//     })

//   } catch (error) {
//     console.error('❌ Erreur lors de la mise à jour:', error)
//     toast.error('Erreur lors de la mise à jour')
//   }
// }

// // Formater la date de dernière synchronisation
// const formatDate = (dateStr) => {
//   if (!dateStr) return '-'
//   const date = new Date(dateStr)
//   const now = new Date()
//   const diffMs = now - date
//   const diffMins = Math.floor(diffMs / 60000)
//   const diffHours = Math.floor(diffMs / 3600000)
//   const diffDays = Math.floor(diffMs / 86400000)

//   if (diffMins < 1) return 'À l\'instant'
//   if (diffMins < 60) return `Il y a ${diffMins} min`
//   if (diffHours < 24) return `Il y a ${diffHours}h`
//   if (diffDays < 7) return `Il y a ${diffDays}j`

//   return date.toLocaleDateString('fr-FR', {
//     day: 'numeric',
//     month: 'short',
//     hour: '2-digit',
//     minute: '2-digit'
//   })
// }

// // Label pour le statut de synchronisation
// const getSyncStatusLabel = (status) => {
//   const labels = {
//     success: 'Synchronisé',
//     pending: 'En attente',
//     error: 'Erreur'
//   }
//   return labels[status] || status
// }

// // Label pour la direction de synchronisation
// const getSyncDirectionLabel = (direction) => {
//   const labels = {
//     bidirectional: 'Bidirectionnelle',
//     import: 'Import',
//     export: 'Export'
//   }
//   return labels[direction] || direction
// }

// Charger au montage du composant
onMounted(async () => {
  await loadConnections()

  // Vérifier si on revient après une connexion Google réussie
  if (route.query.google_connected === 'true') {
    toast.success('Google Calendar connecté avec succès !', {
      position: 'top-right',
      autoClose: 3000
    })
    // Recharger les connexions
    await loadConnections()
    // Nettoyer l'URL
    window.history.replaceState({}, '', '/appointments/import')
  }

  // Vérifier si une erreur est survenue
  if (route.query.google_error === 'true') {
    toast.error('Erreur lors de la connexion à Google Calendar', {
      position: 'top-right',
      autoClose: 3000
    })
    // Nettoyer l'URL
    window.history.replaceState({}, '', '/appointments/import')
  }
})
</script>
